import React, {useState} from 'react';
import {bool, object, func} from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as ArchitectActions from '../../actions/architectActions';
import * as SiteActions from '../../actions/siteActions';

import classes from './TableRowMenu.module.css';

const CampusSitesTableRowMenu = ({
    campusSite,
    hidden,
    onToggleDeleteCampusSiteModal,
    setSite
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
        setSite(campusSite);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleDeleteCampusSite() {
        onToggleDeleteCampusSiteModal(true);

        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                <MenuItem onClick={handleDeleteCampusSite}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Remove Site from Campus
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

CampusSitesTableRowMenu.defaultProps = {
    hidden:                        false,
    onToggleDeleteCampusSiteModal: () => {}
};

CampusSitesTableRowMenu.propTypes = {
    campusSite:                    object,
    hidden:                        bool,
    onToggleDeleteCampusSiteModal: func,
    setSite:                       func
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...SiteActions
};

export default withRouter(
    connect(null, mapDispatchToProps)(CampusSitesTableRowMenu)
);
